module.exports = __webpack_public_path__ + "img/avatar0.da83d89b.png";